// extracted by mini-css-extract-plugin
export default {"maincontent":"About_maincontent__hoQ8U","img":"About_img__wCZXw","linkp":"About_linkp__fuSwE"};